import React, { useEffect } from 'react'
import Loader from 'components/D3Loader'
import Consent from './Consent'
import { FALLBACK_STRINGS } from 'utils/constants'

const ConsentList = ({
    loading,
    consents,
    strings,
    consent_status,
    studyID,
    downloadConsentPDF,
    downloadSignConsentPDF,
    onFetchConsentDetails
}) => {
    return (
        <div className='announcements-list'>
            {loading && <Loader inContainer />}
            {!loading &&
                (consents.length > 0 ? (
                    consents.map((consent, index) => (
                        <Consent
                            downloadConsentPDF={downloadConsentPDF}
                            downloadSignConsentPDF={downloadSignConsentPDF}
                            key={`${consent.consent_id ?? 'consent'}-${index}`}
                            consent={consent}
                            strings={strings}
                            studyID={studyID}
                            onFetchConsentDetails={onFetchConsentDetails}
                            consent_status={consent_status}
                        />
                    ))
                ) : (
                    <div className='no-announcements'>
                        <p>{strings.no_consents_to_display || FALLBACK_STRINGS.no_consents_to_display}</p>
                    </div>
                ))}
        </div>
    )
}

export default ConsentList
